import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Mail, ArrowRight, RefreshCw } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const Verify2FA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const email = location.state?.email || '';
  
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/verify-2fa`, {
        email,
        code
      });
      
      login(response.data.access_token, response.data.user);
      navigate('/portal');
    } catch (err) {
      setError(err.response?.data?.detail || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    setError('');
    
    try {
      await axios.post(`${API}/auth/resend-2fa?email=${email}`);
      alert('Verification code sent! Check your email.');
    } catch (err) {
      setError('Failed to resend code');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-logo">KRYPTON9</h1>
            <h2 className="heading-2">Verify Your Email</h2>
            <p className="body-medium text-secondary">
              We sent a 6-digit code to <strong>{email}</strong>
            </p>
          </div>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label className="body-small">Verification Code</label>
              <div className="input-with-icon">
                <Mail size={18} />
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  className="form-input"
                  placeholder="000000"
                  maxLength="6"
                  pattern="[0-9]{6}"
                />
              </div>
            </div>

            <button type="submit" disabled={loading} className="btn-primary auth-btn">
              {loading ? 'Verifying...' : 'Verify & Continue'}
              <ArrowRight size={16} />
            </button>

            <button 
              type="button" 
              onClick={handleResend} 
              disabled={resending}
              className="btn-secondary auth-btn"
            >
              <RefreshCw size={16} />
              {resending ? 'Resending...' : 'Resend Code'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Verify2FA;
